import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { QRReader } from "./QRReades";
import { fichajeTotem } from "../../services/apis";
import { FichadaDialog } from "./FichadaDialog";
import { CircularProgress, Fab, Grid, Typography, Box } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import { RelojTotem } from "../../utils/componentes-utiles/RelojTotem";
import { CerrarSesion } from "../../utils/componentes-utiles/CerrarSesion";

export const TotemFichajeQr = ({ id }) => {
  const [qrValue, setQrValue] = useState(null);
  const [estado, setEstado] = useState("idle");
  const [data, setData] = useState(null);
  const [totemID] = useState(id);

  const obtenerFechaActual = () => {
    const now = new Date();

    const fecha = now.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const hora = now.toLocaleTimeString("es-ES", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    const [dia, mes, anio] = fecha.split("/");
    return `${anio}-${mes}-${dia} ${hora}`;
  };

  const fichar = async (value) => {
    try {
      setEstado("loading");
      const fechaActual = obtenerFechaActual();

      const response = await fichajeTotem({
        fecha: fechaActual,
        cardCode: value,
        totemCode: totemID,
      });

      if (!response.success) {
        setEstado("error");
        setData(null);
        return;
      }

      setEstado("success");
      setData(response);
    } catch (error) {
      setEstado("error");
      setData(null);
    }
  };

  useEffect(() => {
    if (qrValue) fichar(qrValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qrValue]);

  const resetFichaje = () => {
    setQrValue(null);
    setEstado("idle");
    setData(null);
  };

  return (
    <Dialog
      open={true}
      fullScreen
      PaperProps={{
        sx: {
          background: "linear-gradient(to bottom, #000000, #000000ff)",
          color: "#fff",
          pb: 3,
        },
      }}
    >
      <DialogContent>
        <Grid container direction="column" justifyContent="start" alignItems="start" xs={12}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center" xs={12}>
            <Typography variant="subtitle1">ID totem:{totemID}</Typography>

            <Grid container direction="row" justifyContent="space-between" alignItems="center" xs={12}>
              <Fab
                size="large"
                color="primary"
                onClick={() => window.location.reload()}
                sx={{
                  backgroundColor: "#1f1f1f",
                  boxShadow: "0px 0px 10px #59CE8F4d",
                  "&:hover": { backgroundColor: "#272727" },
                }}
              >
                <CachedIcon
                  sx={{
                    color: "#59CE8Fff",
                    fontSize: 35,
                    "&:hover": { transform: "rotate(-360deg)" },
                    transition: "transform 0.5s ease-in-out",
                  }}
                />
              </Fab>

              <Typography
                variant="h4"
                sx={{ textAlign: "center", color: "#E8F9FD" }}
              >
                Escanea el código QR de tu<br /> tarjeta de empleado
              </Typography>

              <CerrarSesion />
            </Grid>
          </Grid>

          <Grid container direction="column" justifyContent="center" alignItems="center" xs={12} gap={7}>
            {/* CONTENEDOR */}
            <Box
              sx={{
                width: 350,
                height: 350,
                backgroundColor: "#111",
                borderRadius: 3,
                overflow: "hidden",
                border: "4px solid #59CE8Fff",
                boxShadow: "0 0 20px #59CE8F4d",
                position: "relative",
              }}
            >
              {/* QRReader oculto (pero funcionando) */}
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  opacity: 0,           // oculta el preview
                  pointerEvents: "none",
                  transform: "scale(1.01)",
                }}
              >
                <QRReader
                  key={estado}
                  setQrValue={setQrValue}
                  onScan={(value) => {
                    if (value?.trim()) setQrValue(value);
                  }}
                />
              </Box>

              {/* UI visible encima */}
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 2,
                  textAlign: "center",
                  px: 2,
                }}
              >
                <QrCode2Icon sx={{ fontSize: 90, opacity: 0.85 }} />
                <Typography variant="h5">Coloca el QR frente al escáner</Typography>
                <Typography sx={{ opacity: 0.7 }}>
                  Mantén la tarjeta estable 1 segundo
                </Typography>

                {/* “Marco” tipo escáner */}
                <Box
                  sx={{
                    position: "absolute",
                    inset: 20,
                    borderRadius: 2,
                    border: "2px dashed #59CE8F66",
                    boxShadow: "inset 0 0 0 2px #59CE8F22",
                  }}
                />
              </Box>
            </Box>

            <div>
              <RelojTotem />
            </div>
          </Grid>
        </Grid>
      </DialogContent>

      {/* Loader */}
      {estado === "loading" && (
        <Dialog
          open
          fullScreen
          PaperProps={{
            sx: {
              background: "#000c",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
          }}
        >
          <CircularProgress size={120} sx={{ color: "#59CE8Fff" }} />
        </Dialog>
      )}

      {estado !== "idle" && estado !== "loading" && (
        <FichadaDialog onClose={resetFichaje} estado={estado} data={data} />
      )}
    </Dialog>
  );
};
